'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _src = require('./src');

var _src2 = _interopRequireDefault(_src);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _src2.default; /**
                                  * Copyright (c) 2015-present, Zippy Technologies
                                  *
                                  * This source code is licensed under the MIT license found in the
                                  * LICENSE file in the root directory of this source tree.
                                  */
